module.exports = __webpack_public_path__ + "img/sprite.svg?f6eafe33136788feabc9cfbc492e9137";